__turbopack_context__.v({
  "BottomBlocks": "RyAYoq_BottomBlocks",
  "Content": "RyAYoq_Content",
  "FooterHr": "RyAYoq_FooterHr",
  "Overflow": "RyAYoq_Overflow",
  "Root": "RyAYoq_Root",
  "TopBlocks": "RyAYoq_TopBlocks",
});
